import { Buffer3384y49aj0pxr as Buffer } from './Buffer.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { EOFException34hypof9gkxss as EOFException } from './NonJvmPlatform.mjs';
import {
  selectPrefix5tb3rl5iltlw as selectPrefix,
  readUtf8Line36yidw3sdfobh as readUtf8Line,
} from './internal/Buffer.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
} from '../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixd28v1p2u6jau5g as Char__toInt_impl_vasixd,
} from '../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { toByte4i43936u611k as toByte } from '../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { commonIndexOf19ap7p38o0ad6 as commonIndexOf } from './internal/RealBufferedSource.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealBufferedSourceClass;
function RealBufferedSource() {
  if (RealBufferedSourceClass === VOID) {
    class $ {
      constructor(source) {
        this.source_1 = source;
        this.closed_1 = false;
        this.buffer_1 = new (Buffer())();
      }
      get_buffer_bmaafd_k$() {
        return this.buffer_1;
      }
      read_iuuu3k_k$(sink, byteCount) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonRead' call
          // Inline function 'kotlin.require' call
          if (!(byteCount >= 0n)) {
            var message = 'byteCount < 0: ' + byteCount.toString();
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
          }
          // Inline function 'kotlin.check' call
          if (!!this.closed_1) {
            var message_0 = 'closed';
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_0));
          }
          if (this.buffer_1.size_1 === 0n) {
            if (byteCount === 0n) {
              tmp$ret$0 = 0n;
              break $l$block_0;
            }
            var read = this.source_1.read_iuuu3k_k$(this.buffer_1, 8192n);
            if (read === -1n) {
              tmp$ret$0 = -1n;
              break $l$block_0;
            }
          }
          // Inline function 'kotlin.comparisons.minOf' call
          var b = this.buffer_1.size_1;
          var toRead = byteCount <= b ? byteCount : b;
          tmp$ret$0 = this.buffer_1.read_iuuu3k_k$(sink, toRead);
        }
        return tmp$ret$0;
      }
      exhausted_p1jt55_k$() {
        // Inline function 'okio.internal.commonExhausted' call
        // Inline function 'kotlin.check' call
        if (!!this.closed_1) {
          var message = 'closed';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        return this.buffer_1.exhausted_p1jt55_k$() && this.source_1.read_iuuu3k_k$(this.buffer_1, 8192n) === -1n;
      }
      require_37jki9_k$(byteCount) {
        // Inline function 'okio.internal.commonRequire' call
        if (!this.request_hj5jqj_k$(byteCount))
          throw EOFException().new_okio_EOFException_x4jje7_k$();
        return Unit_instance;
      }
      request_hj5jqj_k$(byteCount) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonRequest' call
          // Inline function 'kotlin.require' call
          if (!(byteCount >= 0n)) {
            var message = 'byteCount < 0: ' + byteCount.toString();
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
          }
          // Inline function 'kotlin.check' call
          if (!!this.closed_1) {
            var message_0 = 'closed';
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_0));
          }
          while (this.buffer_1.size_1 < byteCount) {
            if (this.source_1.read_iuuu3k_k$(this.buffer_1, 8192n) === -1n) {
              tmp$ret$0 = false;
              break $l$block;
            }
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      select_3l2gx4_k$(options) {
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'okio.internal.commonSelect' call
          // Inline function 'kotlin.check' call
          if (!!this.closed_1) {
            var message = 'closed';
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
          }
          while (true) {
            var index = selectPrefix(this.buffer_1, options, true);
            switch (index) {
              case -1:
                tmp$ret$0 = -1;
                break $l$block_1;
              case -2:
                if (this.source_1.read_iuuu3k_k$(this.buffer_1, 8192n) === -1n) {
                  tmp$ret$0 = -1;
                  break $l$block_1;
                }

                break;
              default:
                var selectedSize = options.byteStrings_1[index].get_size_woubt6_k$();
                this.buffer_1.skip_csbv9x_k$(fromInt(selectedSize));
                tmp$ret$0 = index;
                break $l$block_1;
            }
          }
        }
        return tmp$ret$0;
      }
      readUtf8LineStrict_40ilic_k$() {
        return this.readUtf8LineStrict_ic80v4_k$(9223372036854775807n);
      }
      readUtf8LineStrict_ic80v4_k$(limit) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonReadUtf8LineStrict' call
          // Inline function 'kotlin.require' call
          if (!(limit >= 0n)) {
            var message = 'limit < 0: ' + limit.toString();
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
          }
          var tmp;
          if (limit === 9223372036854775807n) {
            tmp = 9223372036854775807n;
          } else {
            // Inline function 'kotlin.Long.plus' call
            tmp = add(limit, fromInt(1));
          }
          var scanLength = tmp;
          // Inline function 'kotlin.code' call
          var this_0 = _Char___init__impl__6a9atx(10);
          var tmp$ret$4 = Char__toInt_impl_vasixd(this_0);
          var newline = this.indexOf_89bx75_k$(toByte(tmp$ret$4), 0n, scanLength);
          if (!(newline === -1n)) {
            tmp$ret$0 = readUtf8Line(this.buffer_1, newline);
            break $l$block_0;
          }
          var tmp_0;
          var tmp_1;
          var tmp_2;
          if (scanLength < 9223372036854775807n && this.request_hj5jqj_k$(scanLength)) {
            // Inline function 'kotlin.Long.minus' call
            var tmp$ret$5 = subtract(scanLength, fromInt(1));
            var tmp_3 = this.buffer_1.get_f9lzxq_k$(tmp$ret$5);
            // Inline function 'kotlin.code' call
            var this_1 = _Char___init__impl__6a9atx(13);
            var tmp$ret$6 = Char__toInt_impl_vasixd(this_1);
            tmp_2 = tmp_3 === toByte(tmp$ret$6);
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            // Inline function 'kotlin.Long.plus' call
            var tmp$ret$7 = add(scanLength, fromInt(1));
            tmp_1 = this.request_hj5jqj_k$(tmp$ret$7);
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            var tmp_4 = this.buffer_1.get_f9lzxq_k$(scanLength);
            // Inline function 'kotlin.code' call
            var this_2 = _Char___init__impl__6a9atx(10);
            var tmp$ret$8 = Char__toInt_impl_vasixd(this_2);
            tmp_0 = tmp_4 === toByte(tmp$ret$8);
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = readUtf8Line(this.buffer_1, scanLength);
            break $l$block_0;
          }
          var data = new (Buffer())();
          // Inline function 'okio.minOf' call
          var b = this.buffer_1.size_1;
          // Inline function 'kotlin.comparisons.minOf' call
          var a = fromInt(32);
          var tmp$ret$9 = a <= b ? a : b;
          this.buffer_1.copyTo_960maq_k$(data, 0n, tmp$ret$9);
          // Inline function 'kotlin.comparisons.minOf' call
          var a_0 = this.buffer_1.size_1;
          var tmp$ret$11 = a_0 <= limit ? a_0 : limit;
          throw EOFException().new_okio_EOFException_6rq0ae_k$('\\n not found: limit=' + tmp$ret$11.toString() + ' content=' + data.readByteString_nzt46n_k$().hex_27mj_k$() + '\u2026');
        }
        return tmp$ret$0;
      }
      skip_csbv9x_k$(byteCount) {
        // Inline function 'okio.internal.commonSkip' call
        var byteCount_0 = byteCount;
        // Inline function 'kotlin.check' call
        if (!!this.closed_1) {
          var message = 'closed';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        while (byteCount_0 > 0n) {
          if (this.buffer_1.size_1 === 0n && this.source_1.read_iuuu3k_k$(this.buffer_1, 8192n) === -1n) {
            throw EOFException().new_okio_EOFException_x4jje7_k$();
          }
          var tmp0 = byteCount_0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = this.buffer_1.size_1;
          var toSkip = tmp0 <= b ? tmp0 : b;
          this.buffer_1.skip_csbv9x_k$(toSkip);
          byteCount_0 = subtract(byteCount_0, toSkip);
        }
        return Unit_instance;
      }
      indexOf_89bx75_k$(b, fromIndex, toIndex) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonIndexOf' call
          var fromIndex_0 = fromIndex;
          // Inline function 'kotlin.check' call
          if (!!this.closed_1) {
            var message = 'closed';
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
          }
          // Inline function 'kotlin.require' call
          if (!(0n <= fromIndex_0 ? fromIndex_0 <= toIndex : false)) {
            var message_0 = 'fromIndex=' + fromIndex_0.toString() + ' toIndex=' + toIndex.toString();
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
          }
          while (fromIndex_0 < toIndex) {
            var result = this.buffer_1.indexOf_89bx75_k$(b, fromIndex_0, toIndex);
            if (!(result === -1n)) {
              tmp$ret$0 = result;
              break $l$block_0;
            }
            var lastBufferSize = this.buffer_1.size_1;
            if (lastBufferSize >= toIndex || this.source_1.read_iuuu3k_k$(this.buffer_1, 8192n) === -1n) {
              tmp$ret$0 = -1n;
              break $l$block_0;
            }
            // Inline function 'kotlin.comparisons.maxOf' call
            var a = fromIndex_0;
            fromIndex_0 = a >= lastBufferSize ? a : lastBufferSize;
          }
          tmp$ret$0 = -1n;
        }
        return tmp$ret$0;
      }
      indexOfElement_1qdoco_k$(targetBytes) {
        return this.indexOfElement_nuae9o_k$(targetBytes, 0n);
      }
      indexOfElement_nuae9o_k$(targetBytes, fromIndex) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonIndexOfElement' call
          var fromIndex_0 = fromIndex;
          // Inline function 'kotlin.check' call
          if (!!this.closed_1) {
            var message = 'closed';
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
          }
          while (true) {
            var result = this.buffer_1.indexOfElement_nuae9o_k$(targetBytes, fromIndex_0);
            if (!(result === -1n)) {
              tmp$ret$0 = result;
              break $l$block_0;
            }
            var lastBufferSize = this.buffer_1.size_1;
            if (this.source_1.read_iuuu3k_k$(this.buffer_1, 8192n) === -1n) {
              tmp$ret$0 = -1n;
              break $l$block_0;
            }
            // Inline function 'kotlin.comparisons.maxOf' call
            var a = fromIndex_0;
            fromIndex_0 = a >= lastBufferSize ? a : lastBufferSize;
          }
        }
        return tmp$ret$0;
      }
      rangeEquals_gz1igj_k$(offset, bytes) {
        return this.rangeEquals_bxc2od_k$(offset, bytes, 0, bytes.get_size_woubt6_k$());
      }
      rangeEquals_bxc2od_k$(offset, bytes, bytesOffset, byteCount) {
        var tmp$ret$0;
        $l$block_2: {
          // Inline function 'okio.internal.commonRangeEquals' call
          // Inline function 'kotlin.check' call
          if (!!this.closed_1) {
            var message = 'closed';
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
          }
          if (byteCount < 0) {
            tmp$ret$0 = false;
            break $l$block_2;
          }
          if (offset < 0n) {
            tmp$ret$0 = false;
            break $l$block_2;
          }
          if (bytesOffset < 0 || (bytesOffset + byteCount | 0) > bytes.get_size_woubt6_k$()) {
            tmp$ret$0 = false;
            break $l$block_2;
          }
          if (byteCount === 0) {
            tmp$ret$0 = true;
            break $l$block_2;
          }
          // Inline function 'kotlin.Long.plus' call
          var tmp$ret$3 = add(offset, fromInt(1));
          tmp$ret$0 = !(commonIndexOf(this, bytes, bytesOffset, byteCount, offset, tmp$ret$3) === -1n);
        }
        return tmp$ret$0;
      }
      close_yn9xrc_k$() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonClose' call
          if (this.closed_1) {
            tmp$ret$0 = Unit_instance;
            break $l$block;
          }
          this.closed_1 = true;
          this.source_1.close_yn9xrc_k$();
          this.buffer_1.clear_j9egeb_k$();
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
      toString() {
        // Inline function 'okio.internal.commonToString' call
        return 'buffer(' + toString(this.source_1) + ')';
      }
    }
    initMetadataForClass($, 'RealBufferedSource');
    RealBufferedSourceClass = $;
  }
  return RealBufferedSourceClass;
}
//region block: exports
export {
  RealBufferedSource as RealBufferedSource2k7dkofmgqbx9,
};
//endregion

//# sourceMappingURL=RealBufferedSource.mjs.map
